module.exports = new __parcel__URL__("frostshield.d5242eb9.png").toString();